export function userMenu(_props: unknown): null {
  return null;
}
